/** Lazily created; must be resumed after a user gesture on many browsers (Brave, Safari, Chrome). */
let ctxCache = null;

let lastPrimeAt = 0;

/**
 * Call from login submit, navigation clicks, or any user pointer/keyboard event.
 * Creates/resumes WebAudio and plays an inaudible buffer so later notification tones are allowed.
 */
export function primeNotificationAudioFromUserGesture() {
  try {
    const now = Date.now();
    if (now - lastPrimeAt < 200) return;
    lastPrimeAt = now;

    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctxCache) ctxCache = new AC();
    const ctx = ctxCache;
    void ctx.resume();

    const buf = ctx.createBuffer(1, 1, ctx.sampleRate);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    const t = ctx.currentTime;
    src.start(t);
    src.stop(t + 0.0001);
  } catch (_) {
    /* ignore */
  }
}

function runChime(ctx) {
  const t0 = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.frequency.setValueAtTime(784, t0);
  osc.frequency.setValueAtTime(988, t0 + 0.08);
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(0.22, t0 + 0.02);
  gain.gain.linearRampToValueAtTime(0.16, t0 + 0.1);
  gain.gain.linearRampToValueAtTime(0, t0 + 0.22);
  osc.start(t0);
  osc.stop(t0 + 0.24);
}

/**
 * Short two-tone chime for Socket.IO / toast notifications.
 * If silent, interact once with the page (or log in again) so audio can unlock.
 */
export function playNotificationSound() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctxCache) ctxCache = new AC();
    const ctx = ctxCache;

    const play = () => {
      try {
        if (ctx.state === "running") {
          runChime(ctx);
          return;
        }
        void ctx
          .resume()
          .then(() => {
            runChime(ctx);
          })
          .catch(() => {
            window.setTimeout(() => {
              void ctx.resume().then(() => runChime(ctx)).catch(() => {});
            }, 80);
          });
      } catch (_) {
        /* ignore */
      }
    };

    play();
  } catch (_) {
    /* ignore */
  }
}
